import React from 'react';
import { Container, Row, Col, Card, CardBody, CardTitle, CardText } from 'reactstrap';
import assets from '../../assets/assets';
import {
  FaPlane, FaHotel, FaCar, FaUserTie, FaTicketAlt, FaTrain, FaShip,
  FaPassport, FaFileAlt, FaSyringe, FaShieldAlt, FaExchangeAlt,
  FaHandshake, FaHeadset,
  FaFile,
  FaMoneyBillWave,
  FaGlobe
} from 'react-icons/fa';
import { FaSailboat } from 'react-icons/fa6';

const taglineStyle = {
  color: "white",
  fontFamily: "Playfair, serif",
  fontSize: "clamp(2.8rem, 6vw, 4rem)",
  fontWeight: "bold",
  textAlign: "center",
  textShadow: "2px 2px 10px rgba(0,0,0,0.8)",
};

const servicesData = [
  {
    icon: <FaGlobe size={40} />,
    title: 'Tailor Made Holidays',
    text: 'At <strong>Sha tours</strong>, we specialize in creating tailor-made holidays designed around your unique interests, style, and pace. With years of expertise, we curate personalized itineraries that blend must-see attractions with hidden gems, seamless transport, and comfortable stays. From family vacations and honeymoons to solo adventures and group trips—every journey is customized to match your vision. Whether exploring India’s cultural treasures or discovering the world, we transform your travel dreams into meaningful, memorable experiences.'
  },
  {
    icon: <FaHotel size={40} />,
    title: 'Accommodation',
    text: 'With long-standing partnerships across hotels, resorts, farmhouses, heritage homestays, house boats, camping and glamping, <strong>Sha tours</strong> books accommodations from budget to luxury worldwide. Whether leisure, business or family travel, we secure comfortable, safe and well-located stays that match your preferences and budget. Our trade rates and partner perks — such as upgrades, airport transfers, breakfast, flexible check-in/out and property credits — add value and save you time. Enjoy peace of mind wherever you go.'
  },
  {
    icon: <FaCar size={40} />,
    title: 'Transportation',
    text: '<strong>Sha tours</strong> provide a modern, diverse fleet—from compact cars to luxury coaches—with 24/7 support. Our experienced, multilingual drivers know routes well, act courteously, and respond promptly. All vehicles undergo regular maintenance and safety checks and can be fitted with child seats on request. For added comfort and peace of mind, vehicles include essentials like air conditioning and GPS tracking, plus full insurance coverage during your transfer.'
  },
  {
    icon: <FaUserTie size={40} />,
    title: 'Guide Services',
    text: 'We work with professional local guides who bring destinations to life with their deep knowledge of culture, history, and traditions. Many are multilingual—fluent in English, French, German, Spanish, Italian, Arabic, and more—ensuring smooth communication. Whether for city tours or heritage walks, our guides enrich your journey with authentic insights and personal stories.'
  },
  {
    icon: <FaPlane size={40} />,
    title: 'Air Tickets',
    text: 'Booking flights is one of the most important parts of travel planning, and we make it easy with our reliable air ticketing services. Whether for leisure or business, solo trips or family vacations, we help you find the most convenient routes at the best fares. From economy to business class, our wide airline network and competitive prices ensure great value. With personalized guidance and 24/7 support, we take the stress out of air travel—so you enjoy a smooth journey.'
  },
  {
    icon: <FaTrain size={40} />,
    title: 'Rail Tickets & Luxury Trains',
    text: 'Travel across destinations with ease through our rail ticketing services. From regular train journeys to exclusive luxury trains, we handle your bookings with precision and care. Experience the charm of iconic luxury trains in India—like Palace on Wheels, Maharajas’ Express, and Golden Chariot—that combine heritage, comfort, and world-class service. Whether for short trips or scenic cross-country journeys, we ensure smooth reservations and a memorable rail travel experience tailored to your needs.'
  },
  {
    icon: <FaSailboat size={40} />,
    title: 'Cruises',
    text: 'Discover the joy of cruising with our carefully curated cruise packages. From short getaways to extended voyages, we bring you world-class ships, elegant cabins, and exceptional service. Whether exploring tropical islands, European coastlines, or Southeast Asia’s vibrant shores, every itinerary is designed to match your interests. Onboard, enjoy fine dining, entertainment, and breathtaking views—perfect for families, couples, or adventure seekers. Travel in style and comfort as the sea becomes your pathway to unforgettable memories.'
  },
  {
    icon: <FaPassport size={40} />,
    title: 'Passport',
    text: 'Managing passport formalities can often feel overwhelming. Our team ensures a smooth process for new applications, renewals, or urgent fast-track requests. We guide you through documentation, forms, and fees with complete accuracy, so your passport is ready on time. Beyond issuance, we also assist with corrections, changes of address, and reapplications for lost or damaged passports. With expert support, you can avoid last-minute stress and focus on your travel plans with complete peace of mind.'
  },
  {
    icon: <FaFile size={40} />,
    title: 'VISA Services',
    text: 'Visas can make or break travel plans. At <strong>Sha tours</strong> we simplify the process for tourists, corporate travellers, groups, students and government staff. We check documents, prepare applications, schedule appointments, submit paperwork and track progress for quick, accurate processing. With years of experience and up-to-date rules, we minimise delays and increase approval chances—saving you time and preventing last-minute problems.'
  },
  {
    icon: <FaFileAlt size={40} />,
    title: 'Attestation',
    text: 'Attestation is essential when you need your documents recognized abroad for education, employment, or personal purposes. It involves verification by authorized authorities to confirm authenticity and make your papers legally valid in foreign countries. We assist with attestation of educational certificates, marriage licenses, affidavits, and commercial documents, ensuring smooth acceptance overseas. With our expertise, you can avoid delays and confusion, while focusing on your international goals with confidence.'
  },
  {
    icon: <FaSyringe size={40} />,
    title: 'Inoculation Certifications',
    text: 'We guide travellers on mandatory and recommended inoculation certificates required for international travel. From advising destination-specific vaccination rules to helping you locate authorized health centres, we ensure you meet all health regulations before your journey. Stay compliant, prepared, and worry-free with our expert assistance.'
  },
  {
    icon: <FaShieldAlt size={40} />,
    title: 'Travel Insurance',
    text: 'Travel comes with surprises, and we ensure you’re covered when the unexpected happens. The Travel Insurance protects you against trip cancellations, interruptions, and non-refundable expenses, giving you financial peace of mind. It also provides emergency medical coverage during your journey, so help is always within reach. Plus, with protection for lost or delayed baggage, you’ll never be left stranded without essentials. Whether for a short trip or a long holiday, our plans keep you worry-free.'
  },
  {
    icon: <FaMoneyBillWave size={40} />,
    title: 'Forex',
    text: 'Handling foreign currency doesn’t have to be stressful. With <strong>Sha tours</strong>, you get reliable Foreign Exchange Assistance at competitive rates. Whether you need forex cards, traveller\'s cheques, or currency notes for your leisure, business, study, or pilgrimage trips, we help you access the right currency. We ensure transparency in every transaction, with clear documentation and quick processing, so you can travel with complete peace of mind.'
  },
  {
    icon: <FaHandshake size={40} />,
    title: 'MICE',
    text: 'MICE stands for Meetings, Incentives, Conferences, and Exhibitions, covering the full spectrum of corporate and business travel needs. At <strong>Sha tours</strong>, we provide end-to-end MICE solutions tailored to your company’s objectives. From venue selection, travel arrangements, and accommodation to event logistics, team-building activities, and on-ground coordination—we ensure every detail is managed with precision. Whether it’s a high-level board meeting, a rewarding incentive trip, an international conference, or a large exhibition, our expertise guarantees seamless execution and impactful results. We aim to create meaningful experiences that strengthen relationships, inspire teams, and deliver lasting value to your organization.'
  },
  {
    icon: <FaHeadset size={40} />,
    title: 'Travel Assistance / 24x7 Support',
    text: 'Travel with confidence knowing help is always just a call away. We provide round-the-clock support to ensure your journey is smooth and worry-free. Whether it’s a last-minute change, an emergency, or simply guidance on the go, our team is always available to assist. From the moment you book until you return home, we stand by you—making sure every step of your travel is stress-free.'
  }
];

const Services = () => {
  const [fadeOut, setFadeOut] = React.useState(false);

  const handleEnquireNow = () => {
    setFadeOut(true);
  };

  return (
    <div className="services-page">
      {/* Hero Section */}
      <section
        className="hero-section text-white text-center"
        style={{
          backgroundImage: `url(${assets.service})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          height: '800px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <div data-aos="fade-up">
          <h1 style={taglineStyle}>
            Your tour arrangements made effortless and relaxed.
          </h1>
        </div>
      </section>

      {/* Intro Paragraph */}
      <Container className="my-5">
        <div className="mb-5 text-justify">
          <p style={{ color: '#040695', textAlign: 'justify' }}>
            Our services are built on commitment, quality, and genuine care. From crafting seamless tours to handling every detail with precision, we ensure your travel experience feels effortless and personalized. With our deep expertise and thoughtful planning, every tour is designed to deliver comfort, reliability, and memorable moments. We treat each journey as a promise—one we fulfil with dedication and heartfelt attention.
          </p>
        </div>

        {/* Services Cards Grid */}
        <Row className="g-4">
          {servicesData.map((service, index) => (
            <Col key={index} md={6} lg={4}>
              <Card
                className="h-100 shadow-sm border-0 hover-lift"
                style={{
                  transition: 'all 0.3s ease',
                  cursor: 'default',
                }}
                onMouseEnter={e => e.currentTarget.style.transform = 'translateY(-8px)'}
                onMouseLeave={e => e.currentTarget.style.transform = 'translateY(0)'}
              >
                <CardBody className="d-flex flex-column align-items-center py-5">
                  <div
                    className="mb-4 p-3 rounded-circle"
                    style={{
                      backgroundColor: '#04069510',
                      color: '#040695',
                    }}
                  >
                    {service.icon}
                  </div>
                  <CardTitle tag="h5" className="fw-bold" style={{ color: '#040695' }}>
                    {service.title}
                  </CardTitle>
                  <CardText className="small justify-content-center"  style={{
    color: '#040695',
    textAlign: 'justify',
  }}>
                    {/* Rendering HTML inside CardText */}
                    <div dangerouslySetInnerHTML={{ __html: service.text }} />
                  </CardText>
                </CardBody>
              </Card>
            </Col>
          ))}
        </Row>
      </Container>

      {/* How We Work Section */}
      <Container className="my-5 py-5" style={{ textAlign: 'justify' }}>
        <div className="mb-5">
          <h2 className="text-center display-5 fw-bold" style={{ color: '#040695' }}>
            How We Work?
          </h2>
          <p className="text-center fw-medium mt-3" style={{ color: '#040695' }}>
            “Your Travel, Perfectly Planned”
          </p>
          <p className="mx-auto" style={{ maxWidth: '800px', color: '#040695' }}>
            At <strong>Sha tours</strong>, we are truly passionate about travel and use our expertise and trusted connections to design holidays that feel effortless and unforgettable. Our goal is to create a genuine bond with every traveller, offering personal attention and staying connected before, during, and after your journey.
          </p>
          <p className="mx-auto" style={{ maxWidth: '800px', color: '#040695' }}>
            Travel planning should be simple and stress-free. Vacations are meant for you to relax — not to manage every detail like a host. Let us take care of the hard work, while you sit back and enjoy the journey.
          </p>
        </div>

        <h3 className="text-center fw-bold mb-5" style={{ color: '#040695' }}>
          Our Simple Process
        </h3>

        <Row className="g-5">
          {/* Step 1 */}
          <Col lg={4}>
            <div>
              <h4 className="text-center fw-bold mt-4" style={{ color: '#040695' }}>Discover & Design</h4>
              <p className="px-3" style={{ color: '#040695' }}>
                Your journey begins with a friendly consultation with one of our travel experts — by
                phone, email, or whichever way is most convenient for you. In this conversation, we’ll
                learn about your travel style, dream destinations, preferred dates, special interests,
                and budget.<br /><br />
                Once we’ve understood your preferences, our team designs a personalized itinerary
                that blends the right mix of stays, activities, and unique experiences. We’ll share the
                draft plan with you, welcome your feedback, and fine-tune every detail until it feels
                perfect for your journey.
              </p>
            </div>
          </Col>

          {/* Step 2 */}
          <Col lg={4}>
            <div>
              <h4 className="text-center fw-bold mt-4" style={{ color: '#040695' }}>Confirm & Prepare</h4>
              <p className="px-3" style={{ color: '#040695' }}>
                After you’ve approved the itinerary, we take care of everything — flights, stays,
                transfers, tours, and activities — using our trusted partnerships with top providers.<br /><br />
                Before you set off, we’ll also equip you with all the essentials: your itinerary, flight
                tickets, hotel confirmations, and other travel documents.<br /><br />
                To make your trip even more special, we’ll share insider tips on local experiences,
                must-try restaurants, and hidden gems to help you enjoy your destination like a local.
              </p>
            </div>
          </Col>

          {/* Step 3 */}
          <Col lg={4}>
            <div>
              <h4 className="text-center fw-bold mt-4" style={{ color: '#040695' }}>Travel With Confidence</h4>
              <p className="px-3" style={{ color: '#040695' }}>
                While you’re on your journey, our team is always just a call or message away to
                provide on-trip assistance, whenever you need it. We want your journey to be
                seamless and stress-free, so if any unexpected situations arise, we’ll step in to help
                resolve them quickly.<br /><br />
                While you’re on your journey, our team is always just a call or message away to
                provide on-trip assistance, whenever you need it. We want your journey to be
                seamless and stress-free, so if any unexpected situations arise, we’ll step in to help
                resolve them quickly.
              </p>
            </div>
          </Col>
        </Row>

        {/* Final Touch */}
        <div className="text-center mt-5">
          <p style={{ fontFamily: "Charm, cursive", fontSize: "2rem", color: '#040695', fontWeight: 'bold' }}>
            With <strong>Sha tours</strong> you don’t just travel, you experience the world your way, worry free...
          </p>
        </div>

        <div className="text-center mt-5">
          <a href='/contact'>
            <button
              onClick={handleEnquireNow}
              className={`enquire-btn ${fadeOut ? 'fade-out' : ''}`}
              style={{
                padding: "14px 32px",
                borderRadius: "8px",
                backgroundColor: "#040695",
                color: "white",
                border: "none",
                cursor: "pointer",
                fontSize: "1.1rem",
                fontWeight: "600",
                transition: "all 0.3s ease",
                boxShadow: "0 4px 15px rgba(4, 6, 149, 0.3)",
              }}
              onMouseEnter={(e) => {
                e.target.style.transform = "translateY(-2px)";
                e.target.style.boxShadow = "0 6px 20px rgba(4, 6, 149, 0.4)";
              }}
              onMouseLeave={(e) => {
                e.target.style.transform = "translateY(0)";
                e.target.style.boxShadow = "0 4px 15px rgba(4, 6, 149, 0.3)";
              }}
            >
              Enquire
            </button>
          </a>
        </div>
      </Container>
    </div>
  );
};

export default Services;